



// // import React, { useState, useEffect } from 'react';
// // import './Management.css';
// // import { FaTrash, FaEye, FaPrint } from 'react-icons/fa'; // Added FaPrint
// // import axios from 'axios';

// // import { useLoader } from '../../../../context/LoaderProvider';

// // // Add these imports at the top
// // import jsPDF from 'jspdf';
// // import html2canvas from 'html2canvas';


// // const StandardOrderStatus = () => {


// //     const [data, setData] = useState([]);
// //     const [orders, setOrders] = useState([]);
// //     const { showLoader, hideLoader } = useLoader();
// //     const [loading, setLoading] = useState(false);
// //     const [selectedItems, setSelectedItems] = useState([]);
// //     // Add these with your other useState declarations
// //     const [isPrinting, setIsPrinting] = useState(false);
// //     const [printingOrderId, setPrintingOrderId] = useState(null);
// //     // Add with other state variables
// //     const [allOrdersForSearch, setAllOrdersForSearch] = useState([]);
// //      const [printOrderData, setPrintOrderData] = useState({});


// //     const [vendorId, setVendorId] = useState(null);
// //     const [allOrders, setAllOrders] = useState([]);
// //     const [filteredData, setFilteredData] = useState([]);
// //     const screenWidth = window.innerWidth;
// //     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
// //     // Add these with your other useState declarations:
// //     const [pageSize] = useState(10); // Fixed at 10
// //     const [totalElements, setTotalElements] = useState(0);
// //     const [filteredOrders, setFilteredOrders] = useState([]);
// //     // Add new state for receipt
// //     const [receiptData, setReceiptData] = useState(null);
// //     const [selectedOrderForReceipt, setSelectedOrderForReceipt] = useState(null);

// //     const [hasMorePages, setHasMorePages] = useState(true);
// //     const [pageNumbers, setPageNumbers] = useState([0]); // For P-1, P, P+1

// //     const [statusOrders, setStatusOrders] = useState([]);
// //     const [currentPage, setCurrentPage] = useState(0);
// //     const [totalPages, setTotalPages] = useState(1);
// //     const [isLoadingStatus, setIsLoadingStatus] = useState(false);
// //     const [searchQuery, setSearchQuery] = useState('');
// //     const [selectedDate, setSelectedDate] = useState("");

// //     useEffect(() => {
// //         let filtered = [...statusOrders];

// //         if (selectedDate) {


// //             const s = new Date(selectedDate);
// //             s.setHours(0, 0, 0, 0);

// //             const e = new Date(selectedDate);
// //             e.setHours(23, 59, 59, 999);

// //             filtered = filtered.filter(order => {
// //                 const date = new Date(order.orderDateAndTime);
// //                 return date >= s && date <= e;
// //             });
// //         }

// //         setFilteredOrders(filtered);
// //     }, [selectedDate, statusOrders]);

// //     const fetchOrders = async () => {
// //         if (!vendorId) return;

// //         const token = localStorage.getItem("authToken");

// //         try {
// //             // Fetch ALL active orders
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/orders/status-range`,
// //                 {
// //                     params: {
// //                         vendorId: vendorId,
// //                         fromStatus: "CONFIRMED",
// //                         toStatus: "WAITING_FOR_PICKUP",
// //                     },
// //                     headers: { Authorization: `Bearer ${token}` },
// //                 }
// //             );

// //             let allOrders = response.data || [];

// //             // 🔥 REMOVED FILTER: Keep all orders regardless of userId
// //             // allOrders = allOrders.filter(order => order.userId !== null && order.userId !== undefined);


// //             // Also fetch dine-in orders for relevant statuses
// //             const dineInStatuses = ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"];
// //             const dineInPromises = dineInStatuses.map(status =>
// //                 axios.get(
// //                     `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/${status}`,
// //                     { headers: { Authorization: `Bearer ${token}` } }
// //                 )
// //             );

// //             const dineInResponses = await Promise.all(dineInPromises);
// //             let dineInOrders = dineInResponses.flatMap(res => res.data || []);

// //             // 🔥 REMOVED FILTER DINE-IN: Keep all dine-in orders regardless of userId
// //             // dineInOrders = dineInOrders.filter(order => order.userId !== null && order.userId !== undefined);

// //             // Filter TABLE_DINE_IN orders by cartItems status
// //             dineInOrders = dineInOrders.filter(order =>
// //                 Array.isArray(order.cartItems) &&
// //                 order.cartItems.some(item =>
// //                     ["PROCESSING", "BEING_PREPARED", "ORDER_IS_READY", "WAITING_FOR_PICKUP"].includes(item.orderStatus)
// //                 )
// //             );

// //             // Combine and deduplicate
// //             const combinedOrders = [...allOrders, ...dineInOrders];
// //             const uniqueOrders = combinedOrders.filter(
// //                 (order, index, self) =>
// //                     index === self.findIndex(
// //                         o => (o.cartId && o.cartId === order.cartId) || (o.orderId && o.orderId === order.orderId)
// //                     )
// //             );

// //             // Sort orders by date in ASCENDING order (oldest first)
// //             const sortedOrders = uniqueOrders.sort((a, b) => {
// //                 const dateA = new Date(a.orderDateAndTime || a.cartDateAndTime || 0);
// //                 const dateB = new Date(b.orderDateAndTime || b.cartDateAndTime || 0);
// //                 return dateA - dateB; // For ascending order (oldest first)
// //             });

// //             setOrders(sortedOrders);

// //         } catch (error) {
// //             console.error("❌ Failed to fetch orders:", error.response?.data || error.message);
// //         }
// //     };

// //     // Fetch orders from API
// //     useEffect(() => {
// //         if (!vendorId) return;

// //         const fetchOrders = async () => {
// //             const token = localStorage.getItem("authToken");
// //             if (!token) {
// //                 console.error("Authorization token missing");
// //                 return;
// //             }

// //             try {
// //                 let pageIndex = 0;
// //                 let allNormalOrders = [];
// //                 let morePages = true;

// //                 // 🔵 Fetch ALL PAGINATED ORDERS page by page
// //                 while (morePages) {
// //                     const res = await axios.get(
// //                         `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${pageIndex}/10`,
// //                         { headers: { Authorization: `Bearer ${token}` } }
// //                     );

// //                     const response = res.data;

// //                     if (!response || !Array.isArray(response.content)) break;

// //                     const pageData = response.content;

// //                     if (pageData.length === 0) break;

// //                     allNormalOrders = [...allNormalOrders, ...pageData];

// //                     if (pageData.length < 10) {
// //                         morePages = false;
// //                     } else {
// //                         pageIndex++;
// //                     }
// //                 }

// //                 // 🔵 Fetch DINE-IN completed orders
// //                 const dineInRes = await axios.get(
// //                     `https://backend.maamaas.com/food/api/cart/get/ordertype=TABLE_DINE_IN/${vendorId}/COMPLETED`,
// //                     { headers: { Authorization: `Bearer ${token}` } }
// //                 );

// //                 const dineInRaw = dineInRes.data || [];

// //                 const dineInOrders = dineInRaw.map((order) => ({
// //                     orderId: order.cartId,
// //                     orderDateAndTime: order.cartDateAndTime || new Date().toISOString(),
// //                     appType: "Food",
// //                     orderService: order.orderType,
// //                     userName: order.userName || "Dine-In User",
// //                     paymentMethod: order.paymentMethod || "N/A",
// //                     status: "COMPLETED",
// //                     grandTotal: order.grandTotal || 0,
// //                 }));

// //                 // 🔥 Combine both
// //                 const allData = [...allNormalOrders, ...dineInOrders];


// //                 setAllOrders(allData);
// //                 setFilteredData(allData); // initial display

// //             } catch (error) {
// //                 console.error("Error fetching orders:", error);
// //             }
// //         };

// //         fetchOrders();
// //     }, [vendorId]);

// //     useEffect(() => {
// //         if (!vendorId) return;

// //         fetchOrders(); // Initial fetch

// //         const intervalId = setInterval(fetchOrders, 5000); // Poll every 5 seconds
// //         return () => clearInterval(intervalId);
// //     }, [vendorId]);

// //     const [allFilteredOrders, setAllFilteredOrders] = useState([]);

// //     // Filter orders whenever selectedDate changes
// //     useEffect(() => {
// //         if (!selectedDate) {
// //             setAllFilteredOrders(allOrders);
// //         } else {
// //             const filtered = allOrders.filter((order) => {
// //                 const orderDate = new Date(order.orderDateAndTime)
// //                     .toISOString()
// //                     .split("T")[0];
// //                 return orderDate === selectedDate;
// //             });
// //             setAllFilteredOrders(filtered);
// //         }
// //     }, [selectedDate, allOrders]);

// //     // Then update pagination based on allFilteredOrders
// //     useEffect(() => {
// //         if (allFilteredOrders.length > 0) {
// //             const startIndex = currentPage * 10;
// //             const pageOrders = allFilteredOrders.slice(startIndex, startIndex + 10);

// //             const formatted = pageOrders.map(order => ({
// //                 orderId: order.orderId,
// //                 orderDateAndTime: order.orderDateAndTime,
// //                 orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
// //                 paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
// //                 status: order.status,
// //                 grandTotal: order.grandTotal ?? 0,
// //             }));

// //             setStatusOrders(formatted);
// //             setTotalPages(Math.ceil(allFilteredOrders.length / 10));
// //         }
// //     }, [allFilteredOrders, currentPage]);
// //     useEffect(() => {
// //         const storedVendorId = localStorage.getItem("vendorId");
// //         if (storedVendorId) {
// //             setVendorId(storedVendorId);
// //         }
// //     }, []);



// //     const handleSearch = async () => {
// //         if (!vendorId) return;

// //         // If search is empty, fetch normal orders
// //         if (searchQuery.trim() === '') {
// //             fetchPaginatedOrders(0);
// //             return;
// //         }

// //         setIsLoadingStatus(true);
// //         const token = localStorage.getItem("authToken");

// //         try {
// //             // Use the vendor orders API for search
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
// //                 { headers: { Authorization: `Bearer ${token}` } }
// //             );

// //             let allOrders = response.data || [];

// //             // Apply date filter
// //             if (selectedDate) {
// //                 allOrders = allOrders.filter(order => {
// //                     const orderDate = new Date(order.orderDateAndTime)
// //                         .toISOString()
// //                         .split("T")[0];
// //                     return orderDate === selectedDate;
// //                 });
// //             }

// //             // Apply search filter
// //             const query = searchQuery.toLowerCase().trim();
// //             const filteredOrders = allOrders.filter(order => {
// //                 const orderIdMatch = order.orderId?.toString().toLowerCase().includes(query);
// //                 const userNameMatch = order.userName?.toLowerCase().includes(query);
// //                 const orderTypeMatch = order.orderType?.toLowerCase().includes(query);
// //                 return orderIdMatch || userNameMatch || orderTypeMatch;
// //             });

// //             // Sort and paginate
// //             filteredOrders.sort((a, b) => new Date(b.orderDateAndTime) - new Date(a.orderDateAndTime));

// //             const totalElements = filteredOrders.length;
// //             const totalPages = Math.max(1, Math.ceil(totalElements / 10));

// //             const startIndex = currentPage * 10;
// //             const pageOrders = filteredOrders.slice(startIndex, startIndex + 10);

// //             // Format
// //             const formatted = pageOrders.map(order => ({
// //                 orderId: order.orderId,
// //                 orderDateAndTime: order.orderDateAndTime,
// //                 orderType: order.orderType?.replace(/[_-]/g, "") ?? "N/A",
// //                 paymentMethod: order.paymentMethod?.replace(/[_-]/g, "") ?? "N/A",
// //                 status: order.status,
// //                 grandTotal: order.grandTotal ?? 0,
// //                 userName: order.userName ? order.userName.trim() : "Guest",
// //             }));

// //             setStatusOrders(formatted);
// //             setTotalPages(totalPages);

// //         } catch (error) {
// //             console.error("Search error:", error);
// //             setStatusOrders([]);
// //             setTotalPages(1);
// //         } finally {
// //             setIsLoadingStatus(false);
// //         }
// //     };

// //     useEffect(() => {
// //         if (!vendorId) return;

// //         const fetchData = () => {
// //             const token = localStorage.getItem("authToken"); // ✅ Retrieve token from storage
// //             if (!token) {
// //                 console.warn("No auth token found. Skipping fetch.");
// //                 return;
// //             }

// //             axios
// //                 .get(
// //                     `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
// //                     {
// //                         headers: {
// //                             Authorization: `Bearer ${token}`, // ✅ Include token in header
// //                         },
// //                     }
// //                 )
// //                 .then((res) => setData(res.data))
// //                 .catch((err) =>
// //                     console.error("Error fetching orders with token:", err.response?.data || err.message)
// //                 );
// //         };

// //         fetchData(); // initial fetch

// //         const interval = setInterval(fetchData, 100000); // fetch every 1 second

// //         return () => clearInterval(interval); // cleanup
// //     }, [vendorId]);

// //     const getTotalOrdersCount = async () => {
// //         if (!vendorId) return 0;

// //         const token = localStorage.getItem("authToken");
// //         try {
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/orders/vendor/statistics/${vendorId}`,
// //                 { headers: { Authorization: `Bearer ${token}` } }
// //             );

// //             return response.data.totalOrders || 0;
// //         } catch (error) {
// //             console.error("Error fetching total orders count:", error);
// //             return 0;
// //         }
// //     };


// //     const fetchPaginatedOrders = async (page = 0) => {
// //         if (!vendorId) return;

// //         setIsLoadingStatus(true);
// //         const token = localStorage.getItem("authToken");

// //         try {
// //             // 1. Fetc
// //             // h current page
// //             // showLoader();
// //             let apiUrl = `https://backend.maamaas.com/food/api/orders/vendor/paginated/${vendorId}/${page}/10`;

// //             const params = new URLSearchParams();
// //             if (selectedDate) params.append('date', selectedDate);
// //             if (searchQuery.trim() !== '') params.append('search', searchQuery);

// //             const queryString = params.toString();
// //             if (queryString) apiUrl += `?${queryString}`;

// //             const response = await axios.get(apiUrl, {
// //                 headers: { Authorization: `Bearer ${token}` },
// //             });

// //             const orders = response.data || [];

// //             // 2. Calculate total pages from statistics
// //             let calculatedTotalPages = totalPages; // Keep current by default

// //             // Only recalculate on first page or when filters change
// //             if (page === 0) {
// //                 if (selectedDate || searchQuery.trim() !== '') {
// //                     // For filtered/search results, we need to count differently
// //                     // Fetch all orders and count filtered ones
// //                     const allResponse = await axios.get(
// //                         `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
// //                         { headers: { Authorization: `Bearer ${token}` } }
// //                     );

// //                     let allOrders = allResponse.data || [];

// //                     // Apply same filters
// //                     if (selectedDate) {
// //                         allOrders = allOrders.filter(order => {
// //                             const orderDate = new Date(order.orderDateAndTime)
// //                                 .toISOString()
// //                                 .split("T")[0];
// //                             return orderDate === selectedDate;
// //                         });
// //                     }

// //                     if (searchQuery.trim() !== '') {
// //                         const query = searchQuery.toLowerCase().trim();
// //                         allOrders = allOrders.filter(order => {
// //                             const orderIdMatch = order.orderId?.toString().toLowerCase().includes(query);
// //                             const userNameMatch = order.userName?.toLowerCase().includes(query);
// //                             const orderTypeMatch = order.orderType?.toLowerCase().includes(query);
// //                             return orderIdMatch || userNameMatch || orderTypeMatch;
// //                         });
// //                     }

// //                     calculatedTotalPages = Math.max(1, Math.ceil(allOrders.length / 10));
// //                 } else {
// //                     // Normal view - use statistics API
// //                     const totalOrdersCount = await getTotalOrdersCount();
// //                     calculatedTotalPages = Math.max(1, Math.ceil(totalOrdersCount / 10));
// //                 }

// //             }

// //             // 3. Update state
// //             setStatusOrders(orders);
// //             setTotalPages(calculatedTotalPages); // ✅ Now this is accurate!
// //             setCurrentPage(page);

// //         } catch (error) {
// //             console.error("Error fetching orders:", error);
// //             setStatusOrders([]);
// //             setTotalPages(1);
// //             setCurrentPage(0);
// //         } finally {
// //             setIsLoadingStatus(false);
// //             // hideLoader();
// //         }
// //     };

// //     // Update goNext and goPrevious functions:
// //     const goToFirstPage = () => setCurrentPage(totalPages - totalPages);
// //     const goToPreviousPage = () => setCurrentPage(prev => Math.max(0, prev - 1));
// //     const goToNextPage = () => setCurrentPage(prev => Math.min(totalPages - 1, prev + 1));
// //     const goToLastPage = () => setCurrentPage(totalPages - 1);




// //     const getVisiblePages = () => {
// //         const pages = [];

// //         // Always show current page
// //         pages.push(currentPage);

// //         // Show previous page if exists
// //         if (currentPage > 0) {
// //             pages.unshift(currentPage - 1);
// //         }

// //         // Show next page if exists
// //         if (currentPage < totalPages - 1) {
// //             pages.push(currentPage + 1);
// //         }

// //         // If we have less than 3 pages, add more if available
// //         if (pages.length < 3) {
// //             if (currentPage > 1) {
// //                 pages.unshift(currentPage - 2);
// //             }
// //             if (currentPage < totalPages - 2) {
// //                 pages.push(currentPage + 2);
// //             }
// //         }

// //         // Sort and return unique pages
// //         return [...new Set(pages)].sort((a, b) => a - b);
// //     };
// //     useEffect(() => {
// //         if (vendorId ) {
// //             if (searchQuery.trim() !== '') {
// //                 handleSearch();
// //             } else {
// //                 fetchPaginatedOrders(currentPage);
// //             }
// //         }
// //     }, [currentPage, vendorId, selectedDate, searchQuery]);


// //     const handlePrintReceipt = async (order) => {
// //         setIsPrinting(true);
// //         setPrintingOrderId(order.orderId);

// //         try {
// //             const token = localStorage.getItem("authToken");

// //             // Fetch order details - try both endpoints
// //             let orderDetails = null;

// //             try {
// //                 // Try the same endpoint as your cart file
// //                 const response = await axios.get(
// //                     `https://backend.maamaas.com/food/api/orders/order/${order.orderId}`,
// //                     { headers: { Authorization: `Bearer ${token}` } }
// //                 );
// //                 orderDetails = response.data;
// //             } catch (err1) {
// //                 try {
// //                     const response = await axios.get(
// //                         `https://backend.maamaas.com/food/api/orders/get/${order.orderId}`,
// //                         { headers: { Authorization: `Bearer ${token}` } }
// //                     );
// //                     orderDetails = response.data;
// //                 } catch (err2) {
// //                     console.error("Both endpoints failed:", err1, err2);
// //                     throw new Error("Could not fetch order details");
// //                 }
// //             }

// //             // Set print order data
// //             setPrintOrderData(orderDetails);

// //             // Create receipt HTML using YOUR EXACT handlePrint logic
// //             const printStyles = `
// // <style>
// // @media print {
// //     body {
// //         width: 80mm !important;
// //         margin: 0 auto !important;
// //         padding: 0 !important;
// //         font-family: "Courier New", monospace !important;
// //         font-size: 12px !important;
// //         line-height: 1.25 !important;
// //         font-weight: 700 !important;
// //     }

// //     h1, h2, h3 {
// //         font-weight: 800;
// //         text-align: center;
// //         margin: 0;
// //         padding: 0;
// //         font-size: 16px !important;
// //     }

// //     .big-title {
// //         font-size: 16px !important;
// //         font-weight: 800;
// //         text-align: center;
// //         margin-bottom: 6px;
// //     }

// //     .center-text {
// //         text-align: center;
// //         font-size: 12px !important;
// //         font-weight: 700;
// //     }

// //     .line {
// //         border-top: 1px solid black;
// //         margin: 7px 0;
// //     }

// //     .dashed {
// //         border-top: 1px dashed black;
// //         margin: 7px 0;
// //     }

// //     table {
// //         width: 100%;
// //         font-size: 12px !important;
// //         border-collapse: collapse;
// //     }

// //     th {
// //         padding: 2px 0px;
// //         font-weight: 800;
// //         font-size: 12px !important;
// //     }

// //     td {
// //         padding: 3px 0px;
// //         font-weight: 600;
// //         font-size: 12px !important;
// //     }

// //     .row {
// //         display: flex;
// //         justify-content: space-around;
// //         font-size: 12px !important;
// //         font-weight: 700;
// //         white-space: nowrap;
// //         width: 100%;
// //     }

// //     .grand-label,
// //     .grand-value {
// //         font-size: 18px !important;
// //         font-weight: 800;
// //     }

// //     .footer {
// //         text-align: center;
// //         margin-top: 12px;
// //         font-size: 12px !important;
// //         font-weight: 700;
// //     }

// //     .receipt-buttons, button {
// //         display: none !important;
// //     }

// //     @page {
// //         size: 80mm auto;
// //         margin: 0;
// //     }

// //     .page-break {
// //         page-break-after: always;
// //     }
// // }
// // </style>
// // `;

// //             // Get vendor details for GSTIN/FSSAI
// //             const vendorId = localStorage.getItem("vendorId");
// //             let vendorGstIn = "N/A";
// //             let vendorFssai = "23624032003384";

// //             try {
// //                 const vendorResponse = await axios.get(
// //                     `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
// //                     { headers: { Authorization: `Bearer ${token}` } }
// //                 );
// //                 vendorGstIn = vendorResponse.data?.gstNumber || "N/A";
// //                 vendorFssai = vendorResponse.data?.fssaiNumber || "23624032003384";
// //             } catch (vendorErr) {
// //             }

// //             // Format date and time
// //             const formatDate = (dateString) => {
// //                 try {
// //                     const date = new Date(dateString);
// //                     return date.toLocaleDateString('en-GB');
// //                 } catch {
// //                     return new Date().toLocaleDateString('en-GB');
// //                 }
// //             };

// //             const formatTime = (dateString) => {
// //                 try {
// //                     const date = new Date(dateString);
// //                     return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
// //                 } catch {
// //                     return new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
// //                 }
// //             };

// //             // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break" - SAME AS YOUR CART
// //             const receiptOne = `
// //         <div class="big-title">Take A Break</div>
// //         <div class="line"></div>

// //         <div class="row"><span>OrderID: ${orderDetails.orderId}</span><span>Date: ${orderDetails.date || formatDate(orderDetails.orderDateAndTime)}</span></div>
// //         <div class="row"><span>Type: ${orderDetails.orderType || "Dine In"}</span><span>Time: ${orderDetails.time || formatTime(orderDetails.orderDateAndTime)}</span></div>

// //         <div class="center-text">Payment: ${orderDetails.paymentMethod || "Cash"}</div>

// //         <div class="line"></div>

// //         <table>
// //             <thead>
// //                 <tr>
// //                     <th style="text-align:center;">Item</th>
// //                     <th style="text-align:center;">Qty</th>
// //                 </tr>
// //             </thead>
// //             <tbody>
// //                 ${Array.isArray(orderDetails.order) ? orderDetails.order.map(item => `
// //                     <tr>
// //                         <td style="text-align:center;">${item.dishName || "Item"}</td>
// //                         <td style="text-align:center;">${item.quantity || 1}</td>
// //                     </tr>
// //                 `).join("") : ""}
// //             </tbody>
// //         </table>

// //         <div class="line"></div>
// //     `;

// //             // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break" - SAME AS YOUR CART
// //             const receiptTwo = `
// //         <div class="big-title">Take A Break</div>
// //         <div class="center-text">GSTIN: ${vendorGstIn}</div>
// //         <div class="line"></div>

// //         <div class="row"><span>OrderID: ${orderDetails.orderId}</span><span>Date: ${orderDetails.date || formatDate(orderDetails.orderDateAndTime)}</span></div>
// //         <div class="row"><span>Type: ${orderDetails.orderType || "Dine In"}</span><span>Time: ${orderDetails.time || formatTime(orderDetails.orderDateAndTime)}</span></div>
// //         <div class="center-text">Payment: ${orderDetails.paymentMethod || "Cash"}</div>

// //         <div class="line"></div>

// //         <table class="items-table">
// //             <thead>
// //                 <tr>
// //                     <th style="text-align:center;">Item</th>
// //                     <th style="text-align:center;">Qty</th>
// //                     <th style="text-align:center;">Price</th>
// //                     <th style="text-align:center;">Total</th>
// //                 </tr>
// //             </thead>
// //             <tbody>
// //     ${Array.isArray(orderDetails.order) ? orderDetails.order.map(item => `
// //         <tr>
// //             <td style="text-align:center;"><b>${item.dishName || "Item"}</b></td>
// //             <td style="text-align:center;"><b>${item.quantity || 1}</b></td>
// //             <td style="text-align:center;"><b>₹${(item.price || 0).toFixed(2)}</b></td>
// //             <td style="text-align:center;"><b>₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</b></td>
// //         </tr>
// //     `).join("") : ""}
// // </tbody>

// //         </table>

// //         <div class="line"></div>

// //         <div class="row"><span>SubTotal</span><span>₹${(orderDetails.subTotal || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>Platform</span><span>₹${(orderDetails.platformCharges || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>Service</span><span>₹${(orderDetails.serviceCharge || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>CGST</span><span>₹${(orderDetails.cgst || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>SGST</span><span>₹${(orderDetails.sgst || 0).toFixed(2)}</span></div>

// //         <div class="line"></div>

// //         <div class="row">
// //             <span class="grand-label">Grand Total</span>
// //             <span class="grand-value">₹${(orderDetails.grandTotal || 0).toFixed(2)}</span>
// //         </div>

// //         <div class="dashed"></div>
// //         <div class="center-text">FSSAI: ${vendorFssai}</div>

// //         <div class="footer">
// //             Thank you, visit again<br/>
// //             www.maamaas.com
// //         </div>
// //     `;

// //             // FINAL PRINT CONTENT - SAME FORMAT AS YOUR CART
// //             const finalHTML = `
// //         <!DOCTYPE html>
// //         <html>
// //         <head>
// //             <title>Receipt - ${orderDetails.orderId || 'Order'}</title>
// //             ${printStyles}
// //         </head>
// //         <body>
// //             ${receiptOne}
// //             <div class="page-break"></div>
// //             ${receiptTwo}
// //         </body>
// //         </html>
// //     `;

// //             // Open print window - SAME LOGIC AS YOUR CART
// //             const printWindow = window.open('', '_blank', 'width=800,height=600');

// //             if (!printWindow) {
// //                 alert("Please allow pop-ups to print receipt");
// //                 throw new Error("Popup blocked");
// //             }

// //             printWindow.document.open();
// //             printWindow.document.write(finalHTML);
// //             printWindow.document.close();

// //             printWindow.onload = () => {
// //                 printWindow.print();

// //                 // Listen for afterprint event
// //                 printWindow.onafterprint = () => {
// //                     setTimeout(() => {
// //                         printWindow.close();
// //                     }, 500);
// //                 };

// //                 // Fallback in case afterprint doesn't fire
// //                 setTimeout(() => {
// //                     if (printWindow && !printWindow.closed) {
// //                         printWindow.close();
// //                     }
// //                 }, 3000);
// //             };

// //             setTimeout(() => {
// //                 if (printWindow && !printWindow.closed) {
// //                     printWindow.close();
// //                 }
// //             }, 1000);

// //         } catch (error) {
// //             console.error("Print error:", error);

// //             if (error.message.includes("Popup blocked")) {
// //                 alert("Please allow pop-ups in your browser to print receipts.");
// //             } else {
// //                 alert("Failed to print receipt. Error: " + error.message);
// //             }
// //         } finally {
// //             setIsPrinting(false);
// //             setPrintingOrderId(null);
// //         }
// //     };


// //     const exportAllOrdersForCSV = async () => {
// //         if (!vendorId) {
// //             alert("No vendor ID found");
// //             return;
// //         }

// //         showLoader();
// //         try {
// //             const token = localStorage.getItem("authToken");

// //             // Fetch ALL orders for export (not paginated)
// //             const response = await axios.get(
// //                 `https://backend.maamaas.com/food/api/orders/vendor/${vendorId}`,
// //                 { headers: { Authorization: `Bearer ${token}` } }
// //             );

// //             let allOrders = response.data || [];

// //             // Apply date filter if selected
// //             if (selectedDate) {
// //                 allOrders = allOrders.filter(order => {
// //                     if (!order.orderDateAndTime) return false;
// //                     const orderDate = new Date(order.orderDateAndTime).toISOString().split('T')[0];
// //                     return orderDate === selectedDate;
// //                 });
// //             }

// //             if (allOrders.length === 0) {
// //                 alert("No data to export!");
// //                 hideLoader();
// //                 return;
// //             }

// //             // Build CSV with username column
// //             const headers = ["S.No", "Order ID", "User Name", "Date", "Category", "Type", "Payment", "Order Status", "Amount"];

// //             const rows = allOrders.map((item, index) => [
// //                 index + 1,
// //                 item.orderId,
// //                 item.userName || "Guest", // Add username here
// //                 new Date(item.orderDateAndTime).toLocaleDateString("en-GB"),
// //                 "Food",
// //                 item.orderType || item.orderService,
// //                 item.paymentMethod === "Online_Payment" ? "Online" : item.paymentMethod,
// //                 item.status,
// //                 Math.round(item.grandTotal || 0),
// //             ]);

// //             // Format CSV for Excel compatibility
// //             const formatCell = (cell) => {
// //                 if (cell === null || cell === undefined) return '""';
// //                 const cellStr = String(cell);

// //                 // Escape double quotes by doubling them
// //                 const escaped = cellStr.replace(/"/g, '""');

// //                 // Wrap in quotes if contains comma, quotes, or newline
// //                 if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n') || cellStr.includes('\r')) {
// //                     return `"${escaped}"`;
// //                 }
// //                 return escaped;
// //             };

// //             // Create CSV lines
// //             const csvLines = [headers, ...rows]
// //                 .map(row => row.map(cell => formatCell(cell)).join(','));

// //             // Add BOM (Byte Order Mark) for UTF-8 Excel compatibility
// //             const BOM = '\uFEFF';
// //             const csvContent = BOM + csvLines.join('\r\n'); // Use \r\n for Windows compatibility

// //             // Create blob with proper MIME type
// //             const blob = new Blob([csvContent], {
// //                 type: 'text/csv; charset=utf-8;'
// //             });

// //             // Create download link
// //             const url = URL.createObjectURL(blob);
// //             const link = document.createElement('a');

// //             // Use .csv extension but format it for Excel
// //             const fileName = `Orders_${selectedDate || 'All'}_${new Date().toISOString().split('T')[0]}.csv`;

// //             link.href = url;
// //             link.setAttribute('download', fileName);
// //             link.style.visibility = 'hidden';

// //             document.body.appendChild(link);
// //             link.click();
// //             document.body.removeChild(link);

// //             // Clean up
// //             setTimeout(() => URL.revokeObjectURL(url), 100);

// //             // Optional: Show success message

// //         } catch (error) {
// //             console.error("Export error:", error);
// //             alert("Failed to export data. Please try again.");
// //         } finally {
// //             hideLoader();
// //         }
// //     };


// //     const getStatusTextt = (status) => {
// //         const statusTexts = {
// //             CONFIRMED: "Placed",
// //             PROCESSING: "Preparing",
// //             BEING_PREPARED: "Preparing", // Map to same as PROCESSING
// //             ORDER_IS_READY: "Prepared",
// //             WAITING_FOR_PICKUP: "Dispatched",
// //             DELIVERED: "Delivered",
// //             COMPLETED: "Delivered", // Map to same as DELIVERED
// //             PENDING: "Placed",
// //             ACCEPTED: "Placed",
// //             REJECTED: "Cancelled",
// //             CANCELLED: "Cancelled",
// //         };
// //         return statusTexts[status] || status;
// //     };

// //     // Helper function to get status color - UPDATE THIS TOO
// //     const getStatusColorr = (status) => {
// //         const statusColors = {
// //             CONFIRMED: '#607d8b',          // Gray - Placed
// //             PROCESSING: '#2196F3',         // Blue - Preparing
// //             BEING_PREPARED: '#2196F3',     // Blue - Preparing
// //             ORDER_IS_READY: '#9C27B0',     // Purple - Prepared
// //             WAITING_FOR_PICKUP: '#FF9800', // Orange - Dispatched
// //             DELIVERED: '#4CAF50',          // Green - Delivered
// //             COMPLETED: '#4CAF50',          // Green - Delivered
// //             PENDING: '#607d8b',            // Gray - Placed
// //             ACCEPTED: '#607d8b',           // Gray - Placed
// //             REJECTED: '#f44336',           // Red - Cancelled
// //             CANCELLED: '#f44336',          // Red - Cancelled
// //         };
// //         return statusColors[status] || '#666';
// //     };


// //     return (

// //         <>

// //             <div style={{
// //                 display: 'flex',
// //                 flexDirection: 'column',
// //                 height: '100%',
// //                 minHeight: '55vh',
// //                 position: 'relative'
// //             }}>
// //                 <div className="order-table-container">
// //                     <style>
// //                         {`
// //                 .order-table-container {
// //                   padding: 0px;
// //                   font-family: Arial, sans-serif;
// //                   width: 100%;
// //                   max-width: 100%;
// //                   box-sizing: border-box;
// //                   display: flex;
// //                   flex-direction: column;
// //                   height: 100%;
// //                 }

// //                 /* Fixed Header Section */
// //                 .fixed-header {
// //                   position: sticky;
// //                   top: 0;

// //                   background: white;
// //                   padding: 2px 0;
// //                   border-bottom: 0px solid #e0e0e0;
// //                   margin-bottom: 00px;
// //                 }

// //                 .filters {
// //                   display: flex;
// //                   justify-content: space-between;
// //                   align-items: center;
// //                   flex-wrap: wrap;
// //                   gap: 15px;
// //                   padding: 2px 0;
// //                   width: 100%;
// //                 }

// //                 .filters button {
// //                   padding: 8px 16px;
// //                   background-color: #b15cd6;
// //                   color: #fff;
// //                   border: none;
// //                   border-radius: 5px;
// //                   font-weight: bold;
// //                   cursor: pointer;
// //                   white-space: nowrap;
// //                   font-size: 14px;
// //                   height: 40px;
// //                 }

// //                 /* Scrollable Table Area */
// //                 .table-scroll-area {
// //                   flex: 1;
// //                   overflow-y: auto;
// //                   overflow-x: auto;
// //                   min-height: 60vh;
// //                   max-height: calc(100vh - 250px);
// //                   border: 0px solid #e0e0e0;
// //                   border-radius: 8px;
// //                   margin-bottom: 0px;
// //                   scrollbar-Width:thin;
// //                   -webkit-overflow-scrolling: touch;

// //                 }

// //                 /* Fixed Footer (Pagination) */
// //                 .fixed-footer {
// //                   position: sticky;
// //                   bottom: 0;
// //                   z-index: 100;
// //                   background: white;
// //                   padding: 5px 0;
// //                   border-top: 0px solid #e0e0e0;
// //                   margin-top: auto;
// //                 }

// //                 .pagination-controls {
// //                   display: flex;
// //                   justify-content: center;
// //                   align-items: center;
// //                   padding: 10px 0;
// //                   background: #f8f9fa;
// //                   border-radius: 8px;
// //                   flex-wrap: wrap;
// //                   gap: 10px;
// //                   width: 100%;
// //                 }

// //                 .pagination-buttons {
// //                   display: flex;
// //                   gap: 10px;
// //                   flex-wrap: wrap;
// //                   justify-content: center;
// //                 }

// //                 .pagination-btn {
// //                   padding: 6px 10px;
// //                   background-color: #b15cd6;
// //                   color: white;
// //                   border: none;
// //                   border-radius: 5px;
// //                   cursor: pointer;
// //                   font-weight: bold;
// //                   transition: background 0.3s;
// //                   font-size: 14px;
// //                 }

// //                 .pagination-btn:hover:not(:disabled) {
// //                   background-color: #9a4bc2;
// //                 }

// //                 .pagination-btn:disabled {
// //                   background-color: #ccc;
// //                   cursor: not-allowed;
// //                   color:black;
// //                 }

// //                 /* Table Styles */
// //                 table {
// //                   width: 100%;
// //                   border-collapse: collapse;
// //                   // min-width: 800px;
// //                 }

// //                 thead tr {
// //                   background-color: #b15cd6;
// //                   position: sticky;
// //                   top: 0;
// //                   z-index: 10;
// //                 }
// //                 td{
// //                   padding:0px 8px !important;
// //                 }

// //                 th, td {
// //                   padding: 8px 8px;
// //                   border: 1px solid #e0e0e0;
// //                   text-align: center;
// //                   font-size: 14px;
// //                   word-break: break-word;
// //                   white-space:nowrap;
// //                 }

// //                 tbody tr:nth-child(even) {
// //                   background-color: #f9f9f9;
// //                 }

// //                 tbody tr:nth-child(odd) {
// //                   background-color: #ffffff;
// //                 }

// //                 tbody tr:hover {
// //                   background-color: #f0e6f5;
// //                 }

// //                 /* Responsive Breakpoints */
// //                 @media (max-width: 1400px) {
// //                   table {
// //                     min-width: 700px;
// //                   }

// //                   .table-scroll-area {
// //                     max-height: calc(100vh - 240px);
// //                   }
// //                 }

// //                 @media (max-width: 1200px) {
// //                   table {
// //                     min-width: 600px;
// //                   }

// //                   th, td {
// //                     padding: 10px 12px;
// //                     font-size: 13px;
// //                   }
// //                 }

// //                 @media (max-width: 768px) {
// //                   .filters {
// //                     flex-direction: column;
// //                     align-items: stretch;
// //                     gap: 10px;
// //                   }

// //                   .filters > div {
// //                     width: 100%;
// //                     display: flex;
// //                     justify-content: space-between;
// //                   }

// //                   table {
// //                     min-width: 500px;
// //                   }

// //                   th, td {
// //                     padding: 8px 10px;
// //                     font-size: 12px;

// //                   }

// //                   .table-scroll-area {
// //                     max-height: calc(100vh - 280px);
// //                   }
// //                 }

// //                 @media (max-width: 576px) {
// //                   table {
// //                     min-width: 450px;
// //                   }

// //                   th, td {
// //                     padding: 6px 8px;
// //                     font-size: 11px;
// //                   }

// //                   .pagination-btn {
// //                     min-width: 70px;
// //                     padding: 6px 12px;
// //                     font-size: 12px;
// //                   }
// //                 }
// //                   .pagination-controls {
// //               display: flex;
// //               flex-direction: column;
// //               align-items: center;
// //               padding: 10px 0;
// //               background: #f8f9fa;
// //               border-radius: 8px;
// //               width: 100%;
// //             }

// //             .pagination-buttons {
// //               display: flex;
// //               flex-wrap: nowrap; /* Prevent wrapping */
// //               gap: 8px;
// //               justify-content: center;
// //               align-items: center;
// //               width: 100%;
// //               max-width: 700px; /* Limit maximum width */
// //               overflow-x: auto; /* Allow horizontal scroll if needed */
// //               padding: 5px;
// //             }

// //             .pagination-btn {
// //               padding: 3px 8px;
// //               background-color: #b15cd6;
// //               color: white;
// //               border: none;
// //               border-radius: 5px;
// //               cursor: pointer;
// //               font-weight: bold;
// //               font-size: 14px;
// //               white-space: nowrap;
// //               transition: background 0.3s;
// //               flex-shrink: 0; /* Prevent buttons from shrinking */
// //             }

// //             .pagination-btn:hover:not(:disabled) {
// //               background-color: #9a4bc2;
// //             }

// //             .pagination-btn:disabled {
// //               background-color: #ccc;
// //               cursor: not-allowed;
// //               opacity: 0.7;
// //             }

// //             /* Responsive adjustments */
// //             @media (max-width: 768px) {
// //               .pagination-buttons {
// //                 gap: 5px;
// //                 padding: 5px 2px;
// //               }

// //               .pagination-btn {
// //                 padding: 6px 8px;
// //                 font-size: 12px;
// //                 min-width: auto; /* Remove min-width on mobile */
// //               }

// //               .pagination-btn:first-child,
// //               .pagination-btn:last-child {
// //                 // display: none; /* Hide First/Last on very small screens if needed */
// //               }
// //             }

// //             @media (max-width: 576px) {
// //               .pagination-buttons {
// //                 gap: 3px;
// //               }

// //               .pagination-btn {
// //                 padding: 5px 6px;
// //                 font-size: 11px;
// //               }
// //             }

// //             /* For very small screens, show only essential buttons */
// //             @media (max-width: 400px) {
// //               .pagination-buttons {
// //                 justify-content: space-between;
// //                 width: 100%;
// //               }

// //               .pagination-btn {
// //                 flex: 1; /* Make buttons take equal space */
// //                 padding: 6px 4px;
// //                 font-size: 11px;
// //                 text-align: center;
// //               }
// //             }
// //               @media (max-width:500px){
// //               .filters{
// //               padding:2px;
// //               }
// //               }
// //               .fixed-footer{
// //               padding:0px;
// //               }
// //               .order-table-container {
// //                   padding: 0px;
// //                   font-family: Arial, sans-serif;
// //                   width: 100%;
// //                   max-width: 100%;
// //                   box-sizing: border-box;
// //                   display: flex;
// //                   flex-direction: column;
// //                   height: 100%;
// //                 }

// //                 /* Update table header styles for new column */
// //                 table {
// //                   width: 100%;
// //                   border-collapse: collapse;
// //                   min-width: 800px; /* Increased for new column */
// //                 }

// //                 thead tr {
// //                   background-color: #b15cd6;
// //                   position: sticky;
// //                   top: 0;
// //                   z-index: 10;
// //                 }

// //                 th, td {
// //                   padding: 8px 8px;
// //                   border: 1px solid #e0e0e0;
// //                   text-align: center;
// //                   font-size: 14px;
// //                   word-break: break-word;
// //                   white-space: nowrap;
// //                 }

// //                 /* Print button styles */
// //                 .print-btn {
// //                   background: none;
// //                   border: none;
// //                   cursor: pointer;
// //                   font-size: 18px;
// //                   color: #b15cd6;
// //                   transition: color 0.3s;
// //                   padding: 5px;
// //                   border-radius: 4px;
// //                 }

// //                 .print-btn:hover {
// //                   color: #9a4bc2;
// //                   background: rgba(177, 92, 214, 0.1);
// //                 }

// //                 .print-btn:disabled {
// //                   cursor: not-allowed;
// //                   opacity: 0.5;
// //                 }

// //                 .print-btn.printing {
// //                   animation: pulse 1.5s infinite;
// //                 }

// //                 @keyframes pulse {
// //                   0% { opacity: 1; }
// //                   50% { opacity: 0.5; }
// //                   100% { opacity: 1; }
// //                 }

// //                 .print-dropdown {
// //                   position: relative;
// //                   display: inline-block;
// //                 }

// //                 .print-dropdown-content {
// //                   display: none;
// //                   position: absolute;
// //                   background-color: white;
// //                   min-width: 120px;
// //                   box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
// //                   z-index: 1;
// //                   right: 0;
// //                   top: 100%;
// //                   border-radius: 4px;
// //                   overflow: hidden;
// //                 }

// //                 .print-dropdown:hover .print-dropdown-content {
// //                   display: block;
// //                 }

// //                 .print-option {
// //                   padding: 10px 15px;
// //                   text-decoration: none;
// //                   display: block;
// //                   color: #333;
// //                   font-size: 14px;
// //                   cursor: pointer;
// //                   border-bottom: 1px solid #f0f0f0;
// //                 }

// //                 .print-option:hover {
// //                   background-color: #f5f5f5;
// //                 }

// //                 .print-option:last-child {
// //                   border-bottom: none;
// //                 }

// //                 .print-option i {
// //                   margin-right: 8px;
// //                 }
// //               `}
// //                     </style>

// //                     {/* FIXED HEADER: Date Filter & Export Button */}
// //                     <div className="fixed-header" style={{
// //                         zIndex: window.innerWidth < 768 ? "-1" : "100",
// //                         width: window.innerWidth < 768 ? "94vw" : " "
// //                     }}>
// //                         <div className="filters">
// //                             {/* Main container with two sub-containers */}
// //                             <div style={{
// //                                 display: 'flex',
// //                                 flexDirection: window.innerWidth < 768 ? 'column' : 'row',
// //                                 alignItems: 'stretch',
// //                                 gap: '3px',
// //                                 width: '100%',
// //                                 justifyContent: "space-between"
// //                             }}>

// //                                 {/* LEFT DIV: Export Button and Filter Button (Buttons Section) */}
// //                                 <div style={{
// //                                     display: 'flex',
// //                                     flexDirection: window.innerWidth < 430 ? "row-reverse" : 'row',
// //                                     alignItems: 'center',
// //                                     gap: '10px',
// //                                     flexShrink: 0,
// //                                     justifyContent: "space-between"
// //                                 }}>
// //                                     {/* Export Button */}
// //                                     <button
// //                                         onClick={() => exportAllOrdersForCSV()}
// //                                         style={{
// //                                             height: "40px",
// //                                             padding: "0px 20px",
// //                                             display: "flex",
// //                                             alignItems: "center",
// //                                             justifyContent: "center",
// //                                             whiteSpace: 'nowrap',
// //                                             background: "#b15cd6",
// //                                             color: "#fff",
// //                                             border: "none",
// //                                             borderRadius: "5px",
// //                                             fontWeight: "bold",
// //                                             cursor: "pointer",
// //                                             fontSize: "14px",
// //                                             minWidth: window.innerWidth < 500 ? "80px" : "100px"
// //                                         }}
// //                                     >
// //                                         Export
// //                                     </button>

// //                                     {/* Date Filter Button */}
// //                                     <div style={{ position: 'relative' }}>
// //                                         <input
// //                                             type="date"
// //                                             value={selectedDate}
// //                                             max={new Date().toISOString().split('T')[0]} // Add this line
// //                                             onChange={(e) => setSelectedDate(e.target.value)}
// //                                             style={{
// //                                                 background: "#b15cd6",
// //                                                 color: "#fff",
// //                                                 border: "none",
// //                                                 padding: "0px 16px",
// //                                                 height: "40px",
// //                                                 minWidth: window.innerWidth < 500 ? "120px" : "150px",
// //                                                 cursor: "pointer",
// //                                                 fontSize: "14px",
// //                                                 borderRadius: "5px",
// //                                                 fontWeight: "bold"
// //                                             }}
// //                                         />
// //                                         {/* Optional: Clear date button */}
// //                                         {selectedDate && (
// //                                             <button
// //                                                 onClick={() => setSelectedDate("")}
// //                                                 style={{
// //                                                     position: 'absolute',
// //                                                     right: '5px',
// //                                                     top: '50%',
// //                                                     transform: 'translateY(-50%)',
// //                                                     background: 'none',
// //                                                     border: 'none',
// //                                                     cursor: 'pointer',
// //                                                     color: '#fff',
// //                                                     fontSize: '16px',
// //                                                     padding: '0 5px'
// //                                                 }}
// //                                             >
// //                                                 ×
// //                                             </button>
// //                                         )}
// //                                     </div>
// //                                 </div>

// //                                 {/* RIGHT DIV: Search Bar (Takes remaining space) */}

// //                                 {/* In your search bar div, add a search button */}
// //                                 <div style={{
// //                                     minWidth: window.innerWidth < 768 ? '100%' : '200px'
// //                                 }}>
// //                                     <div style={{
// //                                         display: 'flex',
// //                                         gap: '5px',
// //                                         width: '100%'
// //                                     }}>
// //                                         <div style={{ position: 'relative', flex: 1 }}>
// //                                             <input
// //                                                 type="text"
// //                                                 placeholder="Search by Order ID, Name, or Type..."
// //                                                 value={searchQuery}
// //                                                 onChange={(e) => {
// //                                                     setSearchQuery(e.target.value);
// //                                                     setCurrentPage(0);
// //                                                 }}
// //                                                 onKeyPress={(e) => {
// //                                                     if (e.key === 'Enter') {
// //                                                         if (searchQuery.trim() !== '') {
// //                                                             handleSearch();
// //                                                         } else {
// //                                                             fetchPaginatedOrders(0);
// //                                                         }
// //                                                     }
// //                                                 }}
// //                                                 style={{
// //                                                     width: '100%',
// //                                                     padding: '8px 12px 8px 12px',
// //                                                     border: '1px solid #ddd',
// //                                                     borderRadius: '5px',
// //                                                     fontSize: '14px',
// //                                                     height: '40px',
// //                                                     boxSizing: 'border-box',
// //                                                     outline: "none"
// //                                                 }}
// //                                             />

// //                                             {/* Clear search button */}
// //                                             {searchQuery && (
// //                                                 <button
// //                                                     onClick={() => {
// //                                                         fetchPaginatedOrders(0);
// //                                                         // Use the EXACT same logic as the Search button when it's empt
// //                                                         setSearchQuery('');
// //                                                         setCurrentPage(0);
// //                                                     }}
// //                                                     style={{
// //                                                         position: 'absolute',
// //                                                         right: '8px',
// //                                                         top: '50%',
// //                                                         transform: 'translateY(-50%)',
// //                                                         background: 'none',
// //                                                         border: 'none',
// //                                                         cursor: 'pointer',
// //                                                         color: '#666',
// //                                                         fontSize: '18px',
// //                                                         padding: '0',
// //                                                         width: '20px',
// //                                                         height: '20px',
// //                                                         display: 'flex',
// //                                                         alignItems: 'center',
// //                                                         justifyContent: 'center'
// //                                                     }}
// //                                                     title="Clear search"
// //                                                 >
// //                                                     ×
// //                                                 </button>
// //                                             )}
// //                                         </div>

// //                                         {/* Search Button */}
// //                                         {/* <button
// //                               onClick={() => {
// //                                 if (searchQuery.trim() !== '') {
// //                                   handleSearch();
// //                                 } else {
// //                                   fetchPaginatedOrders(0);
// //                                 }
// //                               }}
// //                               style={{
// //                                 padding: '0px 15px',
// //                                 background: '#b15cd6',
// //                                 color: '#fff',
// //                                 border: 'none',
// //                                 borderRadius: '5px',
// //                                 cursor: 'pointer',
// //                                 fontSize: '14px',
// //                                 whiteSpace: 'nowrap',
// //                                 height: '40px'
// //                               }}
// //                               title="Search"
// //                             >
// //                               Search
// //                             </button> */}
// //                                     </div>
// //                                 </div>

// //                             </div>
// //                         </div>
// //                     </div>



// //                     {/* SCROLLABLE TABLE AREA */}
// //                     <div className="table-scroll-area" style={{ width: window.innerWidth < 768 ? "94vw" : " " }}>
// //                         {isLoadingStatus ? (
// //                             <div style={{
// //                                 display: 'flex',
// //                                 justifyContent: 'center',
// //                                 alignItems: 'center',
// //                                 height: '200px',
// //                                 width: '100%'
// //                             }}>
// //                                 {showLoader && <div>Loading...</div>}
// //                             </div>
// //                         ) : (
// //                             // Update the table to include the print button
// //                             <table>
// //                                 <thead>
// //                                     <tr>
// //                                         {/* <th>S.No</th> */}
// //                                         <th>Order ID</th>
// //                                         <th>User Name</th>
// //                                         <th>Date</th>
// //                                         <th>Category</th>
// //                                         <th>Type</th>
// //                                         <th>Payment</th>
// //                                         <th>Status</th>
// //                                         <th>Amount</th>
// //                                         <th>Print</th>
// //                                     </tr>
// //                                 </thead>

// //                                 <tbody>
// //                                     {statusOrders.length === 0 ? (
// //                                         <tr>
// //                                             <td colSpan="10" style={{
// //                                                 textAlign: "center",
// //                                                 padding: "60px",
// //                                                 fontSize: "16px",
// //                                                 color: "#666"
// //                                             }}>
// //                                                 {selectedDate ? `No orders found for ${selectedDate}` : "No orders found"}
// //                                             </td>
// //                                         </tr>
// //                                     ) : (
// //                                         statusOrders.map((item, index) => (
// //                                             <tr key={index}>
// //                                                 {/* <td>{(currentPage * 10) + index + 1}</td> */}
// //                                                 <td>{item.orderId}</td>
// //                                                 <td>
// //                                                     <span style={{
// //                                                         fontWeight: item.userName !== "Guest" ? "500" : "normal",
// //                                                         color: item.userName !== "Guest" ? "#333" : "#666"
// //                                                     }}>
// //                                                         {item.userName ? item.userName : "Guest"}
// //                                                     </span>
// //                                                 </td>
// //                                                 <td>{new Intl.DateTimeFormat("en-GB").format(new Date(item.orderDateAndTime))}</td>
// //                                                 <td>Food</td>
// //                                                 <td>{item.orderType == "DINE_IN" ? "DINEIN" : item.orderType == "TABLE_DINE_IN" ? "TABLE DINEIN" : item.orderType}</td>
// //                                                 <td>
// //                                                     {item.paymentMethod === "Online_Payment" ? "Online" :
// //                                                         item.paymentMethod === "Maamaas_Wallet" ? "Wallet" :
// //                                                             item.paymentMethod}
// //                                                 </td>
// //                                                 <td>
// //                                                     <span style={{
// //                                                         padding: "4px 8px",
// //                                                         borderRadius: "4px",
// //                                                         fontSize: "12px",
// //                                                         fontWeight: "bold",
// //                                                         backgroundColor: getStatusColorr(item.status),
// //                                                         color: "white",
// //                                                         display: "inline-block",
// //                                                         minWidth: "80px"
// //                                                     }}>
// //                                                         {getStatusTextt(item.status)}
// //                                                     </span>
// //                                                 </td>
// //                                                 <td>₹{Math.round(item.grandTotal)}</td>
// //                                                 <td>
// //                                                     <button
// //                                                         onClick={() => handlePrintReceipt(item)}
// //                                                         disabled={isPrinting && printingOrderId === item.orderId}
// //                                                         style={{
// //                                                             background: 'none',
// //                                                             border: 'none',
// //                                                             cursor: isPrinting && printingOrderId === item.orderId ? 'not-allowed' : 'pointer',
// //                                                             fontSize: '18px',
// //                                                             color: '#b15cd6',
// //                                                             padding: '5px',
// //                                                             borderRadius: '4px',
// //                                                             transition: 'all 0.3s',
// //                                                             opacity: isPrinting && printingOrderId === item.orderId ? 0.5 : 1
// //                                                         }}
// //                                                         title="Print Receipt"
// //                                                         onMouseOver={(e) => {
// //                                                             if (!(isPrinting && printingOrderId === item.orderId)) {
// //                                                                 e.target.style.color = '#9a4bc2';
// //                                                                 e.target.style.background = 'rgba(177, 92, 214, 0.1)';
// //                                                             }
// //                                                         }}
// //                                                         onMouseOut={(e) => {
// //                                                             if (!(isPrinting && printingOrderId === item.orderId)) {
// //                                                                 e.target.style.color = '#b15cd6';
// //                                                                 e.target.style.background = 'none';
// //                                                             }
// //                                                         }}
// //                                                     >
// //                                                         <FaPrint />
// //                                                     </button>
// //                                                 </td>
// //                                             </tr>
// //                                         ))
// //                                     )}
// //                                 </tbody>
// //                             </table>
// //                         )}
// //                     </div>




// //                     {/* FIXED FOOTER: Pagination */}
// //                     {/* FIXED FOOTER: Pagination */}
// //                     {statusOrders.length > 0 && !isLoadingStatus && totalPages > 1 && (
// //                         <div className="fixed-footer">
// //                             <div className="pagination-controls">
// //                                 <div className="pagination-buttons">
// //                                     {/* FIRST PAGE BUTTON */}
// //                                     <button
// //                                         disabled={currentPage === 0 || isLoadingStatus}
// //                                         onClick={goToFirstPage}
// //                                         className="pagination-btn"
// //                                         title="Go to first page"
// //                                     >
// //                                         ⏮
// //                                     </button>

// //                                     {/* PREVIOUS BUTTON */}
// //                                     <button
// //                                         disabled={currentPage === 0 || isLoadingStatus}
// //                                         onClick={goToPreviousPage}
// //                                         className="pagination-btn"
// //                                         title="Previous page"
// //                                     >
// //                                         ◀
// //                                     </button>

// //                                     {/* PAGE NUMBER BUTTONS */}
// //                                     {getVisiblePages().map((pageNum) => (
// //                                         <button
// //                                             key={pageNum}
// //                                             onClick={() => setCurrentPage(pageNum)}
// //                                             className="pagination-btn"
// //                                             style={{
// //                                                 backgroundColor: currentPage === pageNum ? "#31173eff" : "#b15cd6",
// //                                                 fontWeight: currentPage === pageNum ? "bold" : "normal",
// //                                                 minWidth: '40px'
// //                                             }}
// //                                             title={`Go to page ${pageNum + 1}`}
// //                                         >
// //                                             {pageNum + 1}
// //                                         </button>
// //                                     ))}

// //                                     {/* NEXT BUTTON */}
// //                                     <button
// //                                         disabled={currentPage >= totalPages - 1 || isLoadingStatus}
// //                                         onClick={goToNextPage}
// //                                         className="pagination-btn"
// //                                         title="Next page"
// //                                     >
// //                                         ▶
// //                                     </button>

// //                                     {/* LAST PAGE BUTTON */}
// //                                     <button
// //                                         disabled={currentPage >= totalPages - 1 || isLoadingStatus}
// //                                         onClick={goToLastPage}
// //                                         className="pagination-btn"
// //                                         title="Go to last page"
// //                                     >
// //                                         ⏭
// //                                     </button>
// //                                 </div>

// //                             </div>
// //                         </div>
// //                     )}
// //                 </div>
// //             </div>
// //         </>
// //     );
// // }

// // export default StandardOrderStatus




// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { FaPrint } from 'react-icons/fa';

// const StandardOrderStatus = ({ 
//   vendorId, 
//   statusOrders, 
//   isLoadingStatus, 
//   currentPage, 
//   totalPages, 
//   selectedDate, 
//   searchQuery,
//   onPrintReceipt,
//   onExportCSV,
//   onDateChange,
//   onSearchChange,
//   onSearch,
//   onPageChange,
//   isPrinting,
//   printingOrderId
// }) => {
//   const [showLoader, setShowLoader] = useState(false);

//   // Helper function to get status text
//   const getStatusText = (status) => {
//     const statusTexts = {
//       CONFIRMED: "Placed",
//       PROCESSING: "Preparing",
//       BEING_PREPARED: "Preparing",
//       ORDER_IS_READY: "Prepared",
//       WAITING_FOR_PICKUP: "Dispatched",
//       DELIVERED: "Delivered",
//       COMPLETED: "Delivered",
//       PENDING: "Placed",
//       ACCEPTED: "Placed",
//       REJECTED: "Cancelled",
//       CANCELLED: "Cancelled",
//     };
//     return statusTexts[status] || status;
//   };

//   // Helper function to get status color
//   const getStatusColor = (status) => {
//     const statusColors = {
//       CONFIRMED: '#607d8b',
//       PROCESSING: '#2196F3',
//       BEING_PREPARED: '#2196F3',
//       ORDER_IS_READY: '#9C27B0',
//       WAITING_FOR_PICKUP: '#FF9800',
//       DELIVERED: '#4CAF50',
//       COMPLETED: '#4CAF50',
//       PENDING: '#607d8b',
//       ACCEPTED: '#607d8b',
//       REJECTED: '#f44336',
//       CANCELLED: '#f44336',
//     };
//     return statusColors[status] || '#666';
//   };

//   // Pagination helper functions
//   const goToFirstPage = () => onPageChange(0);
//   const goToPreviousPage = () => onPageChange(currentPage - 1);
//   const goToNextPage = () => onPageChange(currentPage + 1);
//   const goToLastPage = () => onPageChange(totalPages - 1);

//   // Helper to get visible pages
//   const getVisiblePages = () => {
//     const pages = [];
//     pages.push(currentPage);

//     if (currentPage > 0) pages.unshift(currentPage - 1);
//     if (currentPage < totalPages - 1) pages.push(currentPage + 1);

//     if (pages.length < 3) {
//       if (currentPage > 1) pages.unshift(currentPage - 2);
//       if (currentPage < totalPages - 2) pages.push(currentPage + 2);
//     }

//     return [...new Set(pages)].sort((a, b) => a - b);
//   };

//   return (
//     <div style={{
//       display: 'flex',
//       flexDirection: 'column',
//       height: '100%',
//       minHeight: '55vh',
//       position: 'relative'
//     }}>
//       <div className="order-table-container">
//         <style>
//           {`
//             .order-table-container {
//               padding: 0px;
//               font-family: Arial, sans-serif;
//               width: 100%;
//               max-width: 100%;
//               box-sizing: border-box;
//               display: flex;
//               flex-direction: column;
//               height: 100%;
//             }

//             /* Fixed Header Section */
//             .fixed-header {
//               position: sticky;
//               top: 0;
//               background: white;
//               padding: 2px 0;
//               border-bottom: 0px solid #e0e0e0;
//               margin-bottom: 00px;
//             }

//             .filters {
//               display: flex;
//               justify-content: space-between;
//               align-items: center;
//               flex-wrap: wrap;
//               gap: 15px;
//               padding: 2px 0;
//               width: 100%;
//             }

//             .filters button {
//               padding: 8px 16px;
//               background-color: #b15cd6;
//               color: #fff;
//               border: none;
//               border-radius: 5px;
//               font-weight: bold;
//               cursor: pointer;
//               white-space: nowrap;
//               font-size: 14px;
//               height: 40px;
//             }

//             /* Scrollable Table Area */
//             .table-scroll-area {
//               flex: 1;
//               overflow-y: auto;
//               overflow-x: auto;
//               min-height: 60vh;
//               max-height: calc(100vh - 250px);
//               border: 0px solid #e0e0e0;
//               border-radius: 8px;
//               margin-bottom: 0px;
//               scrollbar-width: thin;
//               -webkit-overflow-scrolling: touch;
//             }

//             /* Fixed Footer (Pagination) */
//             .fixed-footer {
//               position: sticky;
//               bottom: 0;
//               z-index: 100;
//               background: white;
//               padding: 5px 0;
//               border-top: 0px solid #e0e0e0;
//               margin-top: auto;
//             }

//             .pagination-controls {
//               display: flex;
//               flex-direction: column;
//               align-items: center;
//               padding: 10px 0;
//               background: #f8f9fa;
//               border-radius: 8px;
//               width: 100%;
//             }

//             .pagination-buttons {
//               display: flex;
//               flex-wrap: nowrap;
//               gap: 8px;
//               justify-content: center;
//               align-items: center;
//               width: 100%;
//               max-width: 700px;
//               overflow-x: auto;
//               padding: 5px;
//             }

//             .pagination-btn {
//               padding: 3px 8px;
//               background-color: #b15cd6;
//               color: white;
//               border: none;
//               border-radius: 5px;
//               cursor: pointer;
//               font-weight: bold;
//               font-size: 14px;
//               white-space: nowrap;
//               transition: background 0.3s;
//               flex-shrink: 0;
//             }

//             .pagination-btn:hover:not(:disabled) {
//               background-color: #9a4bc2;
//             }

//             .pagination-btn:disabled {
//               background-color: #ccc;
//               cursor: not-allowed;
//               opacity: 0.7;
//             }

//             /* Table Styles */
//             table {
//               width: 100%;
//               border-collapse: collapse;
//             }

//             thead tr {
//               background-color: #b15cd6;
//               position: sticky;
//               top: 0;
//               z-index: 10;
//             }

//             td {
//               padding: 0px 8px !important;
//             }

//             th, td {
//               padding: 8px 8px;
//               border: 1px solid #e0e0e0;
//               text-align: center;
//               font-size: 14px;
//               word-break: break-word;
//               white-space: nowrap;
//             }

//             tbody tr:nth-child(even) {
//               background-color: #f9f9f9;
//             }

//             tbody tr:nth-child(odd) {
//               background-color: #ffffff;
//             }

//             tbody tr:hover {
//               background-color: #f0e6f5;
//             }

//             /* Print button styles */
//             .print-btn {
//               background: none;
//               border: none;
//               cursor: pointer;
//               font-size: 18px;
//               color: #b15cd6;
//               transition: color 0.3s;
//               padding: 5px;
//               border-radius: 4px;
//             }

//             .print-btn:hover {
//               color: #9a4bc2;
//               background: rgba(177, 92, 214, 0.1);
//             }

//             .print-btn:disabled {
//               cursor: not-allowed;
//               opacity: 0.5;
//             }

//             .print-btn.printing {
//               animation: pulse 1.5s infinite;
//             }

//             @keyframes pulse {
//               0% { opacity: 1; }
//               50% { opacity: 0.5; }
//               100% { opacity: 1; }
//             }

//             /* Responsive Breakpoints */
//             @media (max-width: 1400px) {
//               table {
//                 min-width: 700px;
//               }
//               .table-scroll-area {
//                 max-height: calc(100vh - 240px);
//               }
//             }

//             @media (max-width: 1200px) {
//               table {
//                 min-width: 600px;
//               }
//               th, td {
//                 padding: 10px 12px;
//                 font-size: 13px;
//               }
//             }

//             @media (max-width: 768px) {
//               .filters {
//                 flex-direction: column;
//                 align-items: stretch;
//                 gap: 10px;
//               }
//               .filters > div {
//                 width: 100%;
//                 display: flex;
//                 justify-content: space-between;
//               }
//               table {
//                 min-width: 500px;
//               }
//               th, td {
//                 padding: 8px 10px;
//                 font-size: 12px;
//               }
//               .table-scroll-area {
//                 max-height: calc(100vh - 280px);
//                 width: 94vw;
//               }
//               .fixed-header {
//                 width: 94vw;
//                 z-index: -1;
//               }
//             }

//             @media (max-width: 576px) {
//               table {
//                 min-width: 450px;
//               }
//               th, td {
//                 padding: 6px 8px;
//                 font-size: 11px;
//               }
//               .pagination-btn {
//                 min-width: 70px;
//                 padding: 6px 12px;
//                 font-size: 12px;
//               }
//             }

//             @media (max-width: 500px) {
//               .filters {
//                 padding: 2px;
//               }
//             }
//           `}
//         </style>

//         {/* FIXED HEADER: Date Filter & Export Button */}
//         <div className="fixed-header">
//           <div className="filters">
//             <div style={{
//               display: 'flex',
//               flexDirection: window.innerWidth < 768 ? 'column' : 'row',
//               alignItems: 'stretch',
//               gap: '3px',
//               width: '100%',
//               justifyContent: "space-between"
//             }}>
//               {/* LEFT DIV: Export Button and Filter Button */}
//               <div style={{
//                 display: 'flex',
//                 flexDirection: window.innerWidth < 430 ? "row-reverse" : 'row',
//                 alignItems: 'center',
//                 gap: '10px',
//                 flexShrink: 0,
//                 justifyContent: "space-between"
//               }}>
//                 {/* Export Button */}
//                 <button
//                   onClick={onExportCSV}
//                   style={{
//                     height: "40px",
//                     padding: "0px 20px",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     whiteSpace: 'nowrap',
//                     background: "#b15cd6",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: "5px",
//                     fontWeight: "bold",
//                     cursor: "pointer",
//                     fontSize: "14px",
//                     minWidth: window.innerWidth < 500 ? "80px" : "100px"
//                   }}
//                 >
//                   Export
//                 </button>

//                 {/* Date Filter Button */}
//                 <div style={{ position: 'relative' }}>
//                   <input
//                     type="date"
//                     value={selectedDate}
//                     max={new Date().toISOString().split('T')[0]}
//                     onChange={(e) => onDateChange(e.target.value)}
//                     style={{
//                       background: "#b15cd6",
//                       color: "#fff",
//                       border: "none",
//                       padding: "0px 16px",
//                       height: "40px",
//                       minWidth: window.innerWidth < 500 ? "120px" : "150px",
//                       cursor: "pointer",
//                       fontSize: "14px",
//                       borderRadius: "5px",
//                       fontWeight: "bold"
//                     }}
//                   />
//                   {selectedDate && (
//                     <button
//                       onClick={() => onDateChange("")}
//                       style={{
//                         position: 'absolute',
//                         right: '5px',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         background: 'none',
//                         border: 'none',
//                         cursor: 'pointer',
//                         color: '#fff',
//                         fontSize: '16px',
//                         padding: '0 5px'
//                       }}
//                     >
//                       ×
//                     </button>
//                   )}
//                 </div>
//               </div>

//               {/* RIGHT DIV: Search Bar */}
//               <div style={{
//                 minWidth: window.innerWidth < 768 ? '100%' : '200px'
//               }}>
//                 <div style={{
//                   display: 'flex',
//                   gap: '5px',
//                   width: '100%'
//                 }}>
//                   <div style={{ position: 'relative', flex: 1 }}>
//                     <input
//                       type="text"
//                       placeholder="Search by Order ID, Name, or Type..."
//                       value={searchQuery}
//                       onChange={(e) => {
//                         onSearchChange(e.target.value);
//                       }}
//                       onKeyPress={(e) => {
//                         if (e.key === 'Enter') {
//                           if (searchQuery.trim() !== '') {
//                             onSearch();
//                           }
//                         }
//                       }}
//                       style={{
//                         width: '100%',
//                         padding: '8px 12px 8px 12px',
//                         border: '1px solid #ddd',
//                         borderRadius: '5px',
//                         fontSize: '14px',
//                         height: '40px',
//                         boxSizing: 'border-box',
//                         outline: "none"
//                       }}
//                     />
//                     {searchQuery && (
//                       <button
//                         onClick={() => {
//                           onSearchChange('');
//                         }}
//                         style={{
//                           position: 'absolute',
//                           right: '8px',
//                           top: '50%',
//                           transform: 'translateY(-50%)',
//                           background: 'none',
//                           border: 'none',
//                           cursor: 'pointer',
//                           color: '#666',
//                           fontSize: '18px',
//                           padding: '0',
//                           width: '20px',
//                           height: '20px',
//                           display: 'flex',
//                           alignItems: 'center',
//                           justifyContent: 'center'
//                         }}
//                         title="Clear search"
//                       >
//                         ×
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* SCROLLABLE TABLE AREA */}
//         <div className="table-scroll-area">
//           {isLoadingStatus ? (
//             <div style={{
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               height: '200px',
//               width: '100%'
//             }}>
//               Loading...
//             </div>
//           ) : (
//             <table>
//               <thead>
//                 <tr>
//                   <th>Order ID</th>
//                   <th>User Name</th>
//                   <th>Date</th>
//                   <th>Category</th>
//                   <th>Type</th>
//                   <th>Payment</th>
//                   <th>Status</th>
//                   <th>Amount</th>
//                   <th>Print</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {statusOrders.length === 0 ? (
//                   <tr>
//                     <td colSpan="10" style={{
//                       textAlign: "center",
//                       padding: "60px",
//                       fontSize: "16px",
//                       color: "#666"
//                     }}>
//                       {selectedDate ? `No orders found for ${selectedDate}` : "No orders found"}
//                     </td>
//                   </tr>
//                 ) : (
//                   statusOrders.map((item, index) => (
//                     <tr key={index}>
//                       <td>{item.orderId}</td>
//                       <td>
//                         <span style={{
//                           fontWeight: item.userName !== "Guest" ? "500" : "normal",
//                           color: item.userName !== "Guest" ? "#333" : "#666"
//                         }}>
//                           {item.userName ? item.userName : "Guest"}
//                         </span>
//                       </td>
//                       <td>{new Intl.DateTimeFormat("en-GB").format(new Date(item.orderDateAndTime))}</td>
//                       <td>Food</td>
//                       <td>{item.orderType == "DINE_IN" ? "DINEIN" : item.orderType == "TABLE_DINE_IN" ? "TABLE DINEIN" : item.orderType}</td>
//                       <td>
//                         {item.paymentMethod === "Online_Payment" ? "Online" :
//                           item.paymentMethod === "Maamaas_Wallet" ? "Wallet" :
//                             item.paymentMethod}
//                       </td>
//                       <td>
//                         <span style={{
//                           padding: "4px 8px",
//                           borderRadius: "4px",
//                           fontSize: "12px",
//                           fontWeight: "bold",
//                           backgroundColor: getStatusColor(item.status),
//                           color: "white",
//                           display: "inline-block",
//                           minWidth: "80px"
//                         }}>
//                           {getStatusText(item.status)}
//                         </span>
//                       </td>
//                       <td>₹{Math.round(item.grandTotal)}</td>
//                       <td>
//                         <button
//                           onClick={() => onPrintReceipt(item)}
//                           disabled={isPrinting && printingOrderId === item.orderId}
//                           style={{
//                             background: 'none',
//                             border: 'none',
//                             cursor: isPrinting && printingOrderId === item.orderId ? 'not-allowed' : 'pointer',
//                             fontSize: '18px',
//                             color: '#b15cd6',
//                             padding: '5px',
//                             borderRadius: '4px',
//                             transition: 'all 0.3s',
//                             opacity: isPrinting && printingOrderId === item.orderId ? 0.5 : 1
//                           }}
//                           title="Print Receipt"
//                           onMouseOver={(e) => {
//                             if (!(isPrinting && printingOrderId === item.orderId)) {
//                               e.target.style.color = '#9a4bc2';
//                               e.target.style.background = 'rgba(177, 92, 214, 0.1)';
//                             }
//                           }}
//                           onMouseOut={(e) => {
//                             if (!(isPrinting && printingOrderId === item.orderId)) {
//                               e.target.style.color = '#b15cd6';
//                               e.target.style.background = 'none';
//                             }
//                           }}
//                         >
//                           <FaPrint />
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           )}
//         </div>

//         {/* FIXED FOOTER: Pagination */}
//         {statusOrders.length > 0 && !isLoadingStatus && totalPages > 1 && (
//           <div className="fixed-footer">
//             <div className="pagination-controls">
//               <div className="pagination-buttons">
//                 {/* FIRST PAGE BUTTON */}
//                 <button
//                   disabled={currentPage === 0 || isLoadingStatus}
//                   onClick={goToFirstPage}
//                   className="pagination-btn"
//                   title="Go to first page"
//                 >
//                   ⏮
//                 </button>

//                 {/* PREVIOUS BUTTON */}
//                 <button
//                   disabled={currentPage === 0 || isLoadingStatus}
//                   onClick={goToPreviousPage}
//                   className="pagination-btn"
//                   title="Previous page"
//                 >
//                   ◀
//                 </button>

//                 {/* PAGE NUMBER BUTTONS */}
//                 {getVisiblePages().map((pageNum) => (
//                   <button
//                     key={pageNum}
//                     onClick={() => onPageChange(pageNum)}
//                     className="pagination-btn"
//                     style={{
//                       backgroundColor: currentPage === pageNum ? "#31173eff" : "#b15cd6",
//                       fontWeight: currentPage === pageNum ? "bold" : "normal",
//                       minWidth: '40px'
//                     }}
//                     title={`Go to page ${pageNum + 1}`}
//                   >
//                     {pageNum + 1}
//                   </button>
//                 ))}

//                 {/* NEXT BUTTON */}
//                 <button
//                   disabled={currentPage >= totalPages - 1 || isLoadingStatus}
//                   onClick={goToNextPage}
//                   className="pagination-btn"
//                   title="Next page"
//                 >
//                   ▶
//                 </button>

//                 {/* LAST PAGE BUTTON */}
//                 <button
//                   disabled={currentPage >= totalPages - 1 || isLoadingStatus}
//                   onClick={goToLastPage}
//                   className="pagination-btn"
//                   title="Go to last page"
//                 >
//                   ⏭
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default StandardOrderStatus;




import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaPrint } from 'react-icons/fa';

const StandardOrderStatus = ({
  vendorId,
  statusOrders,
  isLoadingStatus,
  currentPage,
  totalPages,
  selectedDate,
  searchQuery,
  onPrintReceipt,
  onExportCSV,
  onDateChange,
  onSearchChange,
  onSearch,
  onPageChange,
  isPrinting,
  printingOrderId
}) => {
  const [showLoader, setShowLoader] = useState(false);
  const [searchType, setSearchType] = useState('orderId'); // Default search by Order ID
  const [searchPlaceholder, setSearchPlaceholder] = useState('Search by Order ID...');

  // Update placeholder when search type changes
  useEffect(() => {
    switch (searchType) {
      case 'orderId':
        setSearchPlaceholder('Enter Order ID...');
        break;
      case 'userName':
        setSearchPlaceholder('Search by Customer Name...');
        break;
      case 'orderType':
        setSearchPlaceholder('Search by Order Type...');
        break;
      default:
        setSearchPlaceholder('Search...');
    }
  }, [searchType]);

  // Helper function to get status text
  const getStatusText = (status) => {
    const statusTexts = {
      CONFIRMED: "Placed",
      PROCESSING: "Preparing",
      BEING_PREPARED: "Preparing",
      ORDER_IS_READY: "Prepared",
      WAITING_FOR_PICKUP: "Dispatched",
      DELIVERED: "Delivered",
      COMPLETED: "Delivered",
      PENDING: "Placed",
      ACCEPTED: "Placed",
      REJECTED: "Cancelled",
      CANCELLED: "Cancelled",
    };
    return statusTexts[status] || status;
  };

  // Helper function to get status color
  const getStatusColor = (status) => {
    const statusColors = {
      CONFIRMED: '#607d8b',
      PROCESSING: '#2196F3',
      BEING_PREPARED: '#2196F3',
      ORDER_IS_READY: '#9C27B0',
      WAITING_FOR_PICKUP: '#FF9800',
      DELIVERED: '#4CAF50',
      COMPLETED: '#4CAF50',
      PENDING: '#607d8b',
      ACCEPTED: '#607d8b',
      REJECTED: '#f44336',
      CANCELLED: '#f44336',
    };
    return statusColors[status] || '#666';
  };

  // Pagination helper functions
  const goToFirstPage = () => onPageChange(0);
  const goToPreviousPage = () => onPageChange(currentPage - 1);
  const goToNextPage = () => onPageChange(currentPage + 1);
  const goToLastPage = () => onPageChange(totalPages - 1);

  // Helper to get visible pages
  const getVisiblePages = () => {
    const pages = [];
    pages.push(currentPage);

    if (currentPage > 0) pages.unshift(currentPage - 1);
    if (currentPage < totalPages - 1) pages.push(currentPage + 1);

    if (pages.length < 3) {
      if (currentPage > 1) pages.unshift(currentPage - 2);
      if (currentPage < totalPages - 2) pages.push(currentPage + 2);
    }

    return [...new Set(pages)].sort((a, b) => a - b);
  };

  // Handle search with the selected search type
  const handleSearchWithType = () => {
    if (searchQuery.trim() !== '') {
      onSearch(searchType); // Pass the search type to parent
    }
  };

  // Clear search and reset
  const handleClearSearch = () => {
    onSearchChange('');
  };

  // Special handling for Order ID input - show numeric keyboard on mobile
  const getInputType = () => {
    return searchType === 'orderId' ? 'number' : 'text';
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      minHeight: '55vh',
      position: 'relative'
    }}>
      <div className="order-table-container">
        <style>
          {`
          
         /* Simple border glow effect */
.glow-input {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  height: 40px;
  box-sizing: border-box;
  outline: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.glow-input:focus {
  border-color: #b15cd6;
  box-shadow: 0 0 8px rgba(177, 92, 214, 0.6);
}

/* Different glow colors for different search types */
.glow-input[data-search-type="orderId"]:focus {
  border-color: #4CAF50;
  box-shadow: 0 0 8px rgba(76, 175, 80, 0.6);
}

.glow-input[data-search-type="userName"]:focus {
  border-color: #2196F3;
  box-shadow: 0 0 8px rgba(33, 150, 243, 0.6);
}

.glow-input[data-search-type="orderType"]:focus {
  border-color: #FF9800;
  box-shadow: 0 0 8px rgba(255, 152, 0, 0.6);
}

.glow-input[data-search-type="paymentMethod"]:focus {
  border-color: #9C27B0;
  box-shadow: 0 0 8px rgba(156, 39, 176, 0.6);
}

.glow-input[data-search-type="status"]:focus {
  border-color: #607d8b;
  box-shadow: 0 0 8px rgba(96, 125, 139, 0.6);
}
            .order-table-container {
              padding: 0px;
              font-family: Arial, sans-serif;
              width: 100%;
              max-width: 100%;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              height: 100%;
            }

            /* Fixed Header Section */
            .fixed-header {
              position: sticky;
              top: 0;
              background: white;
              padding: 2px 0;
              border-bottom: 0px solid #e0e0e0;
              margin-bottom: 0px;
            }

            .filters {
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              gap: 15px;
              padding: 2px 0;
              width: 100%;
            }

            .filters button {
              padding: 8px 16px;
              background-color: #b15cd6;
              color: #fff;
              border: none;
              border-radius: 5px;
              font-weight: bold;
              cursor: pointer;
              white-space: nowrap;
              font-size: 14px;
              height: 40px;
            }

            /* Search type dropdown */
            .search-type-dropdown {
              position: relative;
              min-width: 150px;
              
            }

            .search-type-select {
              width: 100%;
              padding: 8px 12px;
              background: #b15cd6;
              color: #fff;
              border: none;
              border-radius: 5px;
              font-size: 14px;
              font-weight: bold;
              height: 40px;
              cursor: pointer;
              outline: none;
              appearance: none;
              -webkit-appearance: none;
              -moz-appearance: none;
            }

            .search-type-select option {
              background: white;
              color: #333;
              padding: 10px;
            }

            .search-type-dropdown::after {
              content: '▼';
              position: absolute;
              right: 12px;
              top: 50%;
              transform: translateY(-50%);
              color: #fff;
              pointer-events: none;
              font-size: 12px;
            }

            /* Scrollable Table Area */
            .table-scroll-area {
              flex: 1;
              overflow-y: auto;
              overflow-x: auto;
              min-height: 55vh;
              max-height: calc(100vh - 250px);
              border: 0px solid #e0e0e0;
              border-radius: 8px;
              margin-bottom: 0px;
              scrollbar-width: thin;
              -webkit-overflow-scrolling: touch;
            }

            /* Fixed Footer (Pagination) */
            .fixed-footer {
              position: sticky;
              bottom: 0;
              z-index: 100;
              background: white;
              padding: 5px 0;
              border-top: 0px solid #e0e0e0;
              margin-top: auto;
            }

            .pagination-controls {
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 10px 0;
              // background: #f8f9fa;
              border-radius: 8px;
              width: 100%;
            }

            .pagination-buttons {
              display: flex;
              flex-wrap: nowrap;
              gap: 8px;
              justify-content: center;
              align-items: center;
              width: 100%;
              max-width: 700px;
              overflow-x: auto;
              padding: 5px;
            }

            .pagination-btn {
              padding: 3px 8px;
              background-color: #b15cd6;
              color: white;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              font-weight: bold;
              font-size: 14px;
              white-space: nowrap;
              transition: background 0.3s;
              flex-shrink: 0;
            }

            .pagination-btn:hover:not(:disabled) {
              background-color: #9a4bc2;
            }

            .pagination-btn:disabled {
              background-color: #ccc;
              cursor: not-allowed;
              opacity: 0.7;
            }

            /* Table Styles */
            table {
              width: 100%;
              border-collapse: collapse;
            }

            thead tr {
              background-color: #b15cd6;
              position: sticky;
              top: 0;
              z-index: 10;
            }

            td {
              padding: 0px 8px !important;
            }

            th, td {
              padding: 8px 8px;
              border: 1px solid #e0e0e0;
              text-align: center;
              font-size: 14px;
              word-break: break-word;
              white-space: nowrap;
            }

            tbody tr:nth-child(even) {
              background-color: #f9f9f9;
            }

            tbody tr:nth-child(odd) {
              background-color: #ffffff;
            }

            tbody tr:hover {
              background-color: #f0e6f5;
            }

            /* Print button styles */
            .print-btn {
              background: none;
              border: none;
              cursor: pointer;
              font-size: 18px;
              color: #b15cd6;
              transition: color 0.3s;
              padding: 5px;
              borderRadius: 4px;
            }

            .print-btn:hover {
              color: #9a4bc2;
              background: rgba(177, 92, 214, 0.1);
            }

            .print-btn:disabled {
              cursor: not-allowed;
              opacity: 0.5;
            }

            .print-btn.printing {
              animation: pulse 1.5s infinite;
            }

            @keyframes pulse {
              0% { opacity: 1; }
              50% { opacity: 0.5; }
              100% { opacity: 1; }
            }

            /* Responsive Breakpoints */
            @media (max-width: 1400px) {
              table {
                min-width: 700px;
              }
              .table-scroll-area {
                max-height: calc(100vh - 240px);
              }
            }

            @media (max-width: 1200px) {
              table {
                min-width: 600px;
              }
              th, td {
                padding: 10px 12px;
                font-size: 13px;
              }
            }

            @media (max-width: 768px) {
              .filters {
                flex-direction: column;
                align-items: stretch;
                gap: 10px;
              }
                .table-scroll-area {
                min-height:40vh;
                }
              .filters > div {
                width: 100%;
                display: flex;
                justify-content: space-between;
              }
              .search-type-dropdown {
                min-width: 120px;
              }
              .search-type-select {
                font-size: 13px;
                padding: 8px 10px;
              }
              table {
                min-width: 500px;
              }
              th, td {
                padding: 8px 10px;
                font-size: 12px;
              }
              .table-scroll-area {
                max-height: calc(100vh - 280px);
                width: 94vw;
              }
              .fixed-header {
                width: 94vw;
                z-index: -1;
              }
            }

            @media (max-width: 576px) {
              .search-container {
                flex-direction: column;
                gap: 8px;
              }
              .search-type-dropdown {
                width: 100%;
              }
              table {
                min-width: 450px;
              }
              th, td {
                padding: 6px 8px;
                font-size: 11px;
              }
              .pagination-btn {
                min-width: 70px;
                padding: 6px 12px;
                font-size: 12px;
              }
            }

            @media (max-width: 500px) {
              .filters {
                padding: 2px;
              }
            }
        
          `}
        </style>

        {/* FIXED HEADER: Date Filter & Export Button */}
        <div className="fixed-header">
          <div className="filters">
            <div style={{
              display: 'flex',
              flexDirection: window.innerWidth < 768 ? 'column' : 'row',
              alignItems: 'stretch',
              gap: '15px',
              width: '100%',
              justifyContent: "space-between"
            }}>
              {/* LEFT DIV: Export Button and Filter Button */}
              <div style={{
                display: 'flex',
                flexDirection: window.innerWidth < 430 ? "row-reverse" : 'row',
                alignItems: 'center',
                gap: '10px',
                flexShrink: 0,
                justifyContent: "space-between"
              }}>
                {/* Export Button */}
                <button
                  onClick={onExportCSV}
                  style={{
                    height: "40px",
                    padding: "0px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    whiteSpace: 'nowrap',
                    background: "#b15cd6",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    fontSize: "14px",
                    minWidth: window.innerWidth < 500 ? "80px" : "100px"
                  }}
                >
                  Export
                </button>

                {/* Date Filter Button */}
                <div style={{ position: 'relative' }}>
                  <input
                    type="date"
                    value={selectedDate}
                    max={new Date().toISOString().split('T')[0]}
                    onChange={(e) => onDateChange(e.target.value)}
                    style={{
                      background: "#b15cd6",
                      color: "#fff",
                      border: "none",
                      padding: "0px 16px",
                      height: "40px",
                      minWidth: window.innerWidth < 500 ? "120px" : "150px",
                      cursor: "pointer",
                      fontSize: "14px",
                      borderRadius: "5px",
                      fontWeight: "bold"
                    }}
                  />
                  {selectedDate && (
                    <button
                      onClick={() => onDateChange("")}
                      style={{
                        position: 'absolute',
                        right: '5px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#fff',
                        fontSize: '16px',
                        padding: '0 5px'
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>

              {/* RIGHT DIV: Search Type Dropdown and Search Bar */}
              <div style={{
                minWidth: window.innerWidth < 768 ? '100%' : '350px'
              }}>
                <div className="search-container" style={{
                  display: 'flex',
                  gap: '8px',
                  width: '100%',
                  flexDirection: window.innerWidth < 576 ? 'column' : 'row'
                }}>
                  {/* Search Type Dropdown */}
                  <div className="search-type-dropdown">
                    <select
                      value={searchType}
                      onChange={(e) => setSearchType(e.target.value)}
                      className="search-type-select"
                    >
                      <option value="orderId">Order ID</option>
                      <option value="userName">Customer Name</option>
                      <option value="orderType">Order Type</option>

                    </select>
                  </div>

                  {/* Search Bar */}
                  {/* Search Bar */}
                  <div style={{
                    position: 'relative',
                    flex: 1,
                    width: window.innerWidth < 576 ? '100%' : 'auto'
                  }}>
                    <input
                      type={getInputType()}
                      placeholder={searchPlaceholder}
                      value={searchQuery}
                      onChange={(e) => onSearchChange(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchWithType();
                        }
                      }}
                      className="glow-input"
                      data-search-type={searchType} // For CSS targeting
                      style={{
                        width: '100%',
                        padding: '8px 12px 8px 12px',
                        border: '2px solid #ddd',
                        borderRadius: '5px',
                        fontSize: '14px',
                        height: '40px',
                        boxSizing: 'border-box',
                        outline: 'none'
                      }}
                    />

                    {/* Clear search button */}
                    {searchQuery && (
                      <button
                        onClick={handleClearSearch}
                        style={{
                          position: 'absolute',
                          right: '10px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'none',
                          border: 'none',
                          cursor: 'pointer',
                          color: '#666',
                          fontSize: '18px',
                          padding: '0',
                          width: '20px',
                          height: '20px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        title="Clear search"
                      >
                        ×
                      </button>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SCROLLABLE TABLE AREA */}
        <div className="table-scroll-area">
          {isLoadingStatus ? (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
              width: '100%'
            }}>
              Loading...
            </div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th style={{color:"white"}}>Order ID</th>
                  <th style={{color:"white"}}>User Name</th>
                  <th style={{color:"white"}}>Date</th>
                  <th style={{color:"white"}}>Category</th>
                  <th style={{color:"white"}}>Type</th>
                  <th style={{color:"white"}}>Payment</th>
                  <th style={{color:"white"}}>Status</th>
                  <th style={{color:"white"}}>Amount</th>
                  <th style={{color:"white"}}>Print</th>
                </tr>
              </thead>

              <tbody>
                {statusOrders.length === 0 ? (
                  <tr>
                    <td colSpan="10" style={{
                      textAlign: "center",
                      padding: "60px",
                      fontSize: "16px",
                      color: "#666"
                    }}>
                      {searchQuery
                        ? `No orders found for "${searchQuery}" in ${searchType.replace(/([A-Z])/g, ' $1').toLowerCase()}`
                        : selectedDate
                          ? `No orders found for ${selectedDate}`
                          : "No orders found"
                      }
                    </td>
                  </tr>
                ) : (
                  statusOrders.map((item, index) => (
                    <tr key={index}>
                      <td>{item.orderId}</td>
                      <td>
                        <span style={{
                          fontWeight: item.userName !== "Guest" ? "500" : "normal",
                          color: item.userName !== "Guest" ? "#333" : "#666"
                        }}>
                          {item.userName ? item.userName : "Guest"}
                        </span>
                      </td>
                      <td>{new Intl.DateTimeFormat("en-GB").format(new Date(item.orderDateAndTime))}</td>
                      <td>Food</td>
                      <td>{item.orderType == "DINE_IN" ? "DINEIN" : item.orderType == "TABLE_DINE_IN" ? "TABLE DINEIN" : item.orderType}</td>
                      <td>
                        {item.paymentMethod === "Online_Payment" ? "Online" :
                          item.paymentMethod === "Maamaas_Wallet" ? "Wallet" :
                            item.paymentMethod}
                      </td>
                      <td>
                        <span style={{
                          padding: "4px 8px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          fontWeight: "bold",
                          backgroundColor: getStatusColor(item.status),
                          color: "white",
                          display: "inline-block",
                          minWidth: "80px"
                        }}>
                          {getStatusText(item.status)}
                        </span>
                      </td>
                      <td>₹{Math.round(item.grandTotal)}</td>
                      <td>
                        <button
                          onClick={() => onPrintReceipt(item)}
                          disabled={isPrinting && printingOrderId === item.orderId}
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: isPrinting && printingOrderId === item.orderId ? 'not-allowed' : 'pointer',
                            fontSize: '18px',
                            color: '#b15cd6',
                            padding: '5px',
                            borderRadius: '4px',
                            transition: 'all 0.3s',
                            opacity: isPrinting && printingOrderId === item.orderId ? 0.5 : 1
                          }}
                          title="Print Receipt"
                          onMouseOver={(e) => {
                            if (!(isPrinting && printingOrderId === item.orderId)) {
                              e.target.style.color = '#9a4bc2';
                              e.target.style.background = 'rgba(177, 92, 214, 0.1)';
                            }
                          }}
                          onMouseOut={(e) => {
                            if (!(isPrinting && printingOrderId === item.orderId)) {
                              e.target.style.color = '#b15cd6';
                              e.target.style.background = 'none';
                            }
                          }}
                        >
                          <FaPrint />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          )}
        </div>

        {/* FIXED FOOTER: Pagination */}
        {statusOrders.length > 0 && !isLoadingStatus && totalPages > 1 && (
          <div className="fixed-footer">
            <div className="pagination-controls">
              <div className="pagination-buttons">
                {/* FIRST PAGE BUTTON */}
                <button
                  disabled={currentPage === 0 || isLoadingStatus}
                  onClick={goToFirstPage}
                  className="pagination-btn"
                  title="Go to first page"
                >
                  ⏮
                </button>

                {/* PREVIOUS BUTTON */}
                <button
                  disabled={currentPage === 0 || isLoadingStatus}
                  onClick={goToPreviousPage}
                  className="pagination-btn"
                  title="Previous page"
                >
                  ◀
                </button>

                {/* PAGE NUMBER BUTTONS */}
                {getVisiblePages().map((pageNum) => (
                  <button
                    key={pageNum}
                    onClick={() => onPageChange(pageNum)}
                    className="pagination-btn"
                    style={{
                      backgroundColor: currentPage === pageNum ? "#31173eff" : "#b15cd6",
                      fontWeight: currentPage === pageNum ? "bold" : "normal",
                      minWidth: '40px'
                    }}
                    title={`Go to page ${pageNum + 1}`}
                  >
                    {pageNum + 1}
                  </button>
                ))}

                {/* NEXT BUTTON */}
                <button
                  disabled={currentPage >= totalPages - 1 || isLoadingStatus}
                  onClick={goToNextPage}
                  className="pagination-btn"
                  title="Next page"
                >
                  ▶
                </button>

                {/* LAST PAGE BUTTON */}
                <button
                  disabled={currentPage >= totalPages - 1 || isLoadingStatus}
                  onClick={goToLastPage}
                  className="pagination-btn"
                  title="Go to last page"
                >
                  ⏭
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StandardOrderStatus;